<!-- https://primefaces.org/primeng/showcase/#/setup -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top" style="background-color: #ffffff">
	<div class="selector-body">
		<!-- 				 -->
		<!-- School Selector -->
		<!-- 				 -->
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SelectedSchool"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r">{{r.SchoolNumber}} - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="SchoolSelectShowAll" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText">
				</caass-schoolselector>
			</div>
		</div>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleActive()">Toggle Active</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onToggleBasic()">Toggle Basic</button>
		<button class="btn btn-success" style="margin-left: 5px" (click)="onEdit()">Edit</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total Infractions: {{ lstInfraction.length }}</label
		><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
		<div class="error-div">
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 				  	      -->
<!-- Display Infraction Items -->
<!-- 					      -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->

	<p-table
		#mydt
		[value]="lstInfraction"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedInfraction"
		dataKey="InfractionID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<ng-template pTemplate="header">
			<!-- 				-->
			<!-- Filter Section -->
			<!-- 				-->
			<tr>
				<th class="fixwidth-06">
					<div class="table-filter-row-group">
						<!-- 				   -->
						<!-- Display When Busy -->
						<!-- 				   -->
						<div [style.display]="isBusy == true ? 'block' : 'none'" style="width: 20px">
							<img class="busy-img" src="assets/images/loading.gif" />
						</div>
						<div [style.display]="isBusy == false ? 'block' : 'none'" style="width: 20px"></div>
					</div>
				</th>

				<th class="fixwidth-09">
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDescs"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="fixwidth-09">
					<p-columnFilter field="IsBasicModeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsBasicModeDesc
								[ngModel]="value"
								[options]="lstIsBasicModeDescs"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="InfractionCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="InfractionDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="PenaltyDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="InfractionLevelDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterInfractionLevelDesc
								[ngModel]="value"
								[options]="lstInfractionLevelDescs"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="fixwidth-12">
					<p-columnFilter field="SchoolsDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolsDesc
								[ngModel]="value"
								[options]="lstSchoolsDescs"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th class="fixwidth-12">
					<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefinedByDesc
								[ngModel]="value"
								[options]="lstDefinedByDescs"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr style="height: 4rem">
				<th class="fixwidth-06"></th>
				<th pSortableColumn="Active" class="fixwidth-09">Active<p-sortIcon field="Active"></p-sortIcon></th>
				<th pSortableColumn="IsBasicMode" class="fixwidth-09">Basic<p-sortIcon field="IsBasicMode"></p-sortIcon></th>
				<th pSortableColumn="InfractionCD">Code<p-sortIcon field="InfractionCD"></p-sortIcon></th>
				<th pSortableColumn="InfractionDesc">Description<p-sortIcon field="InfractionDesc"></p-sortIcon></th>
				<th pSortableColumn="PenaltyDesc">Default Action<p-sortIcon field="PenaltyDesc"></p-sortIcon></th>
				<th pSortableColumn="InfractionLevelID">Level<p-sortIcon field="InfractionLevelID"></p-sortIcon></th>
				<th pSortableColumn="SchoolsDesc" class="fixwidth-12">Schools<p-sortIcon field="SchoolsDesc"></p-sortIcon></th>
				<th pSortableColumn="DefinedByDesc" class="fixwidth-12">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rInfractionItem>
			<tr [pSelectableRow]="rInfractionItem" (dblclick)="onRowDblClick(rInfractionItem)">
				<td class="fixwidth-06">
					<!-- Fee space filler -->
				</td>

				<td>
					<div class="fixwidth-09">
						<i
							class="pi"
							[ngClass]="{
								'pi-check-circle table-active': rInfractionItem.Active,
								'pi-ban table-inactive': !rInfractionItem.Active
							}"
						></i>
					</div>
				</td>

				<td>
					<div class="fixwidth-09">
						<i
							class="pi"
							[ngClass]="{
								'pi-check-circle table-active': rInfractionItem.IsBasicMode,
								'pi-ban table-inactive': !rInfractionItem.IsBasicMode
							}"
						></i>
					</div>
				</td>

				<td>
					<div class="table-data-Desc">
						{{ rInfractionItem.InfractionCD }}
					</div>
				</td>

				<td>
					<div class="table-data-Desc">
						{{ rInfractionItem.InfractionDesc }}
					</div>
				</td>

				<td>
					<div class="table-data-Desc">
						{{ rInfractionItem.PenaltyDesc }}
					</div>
				</td>

				<td>
					<div class="table-data-Desc">
						{{ rInfractionItem.InfractionLevelDesc }}
					</div>
				</td>

				<td>
					<div
						class="table-data-Desc fixwidth-12"
						[ngClass]="{
							'table-color-def-1': rInfractionItem.SchoolID <= 0,
							'table-color-def-4': rInfractionItem.SchoolID > 0
						}"
					>
						{{ rInfractionItem.SchoolsDesc }}
					</div>
				</td>

				<td>
					<div
						class="table-data-Desc fixwidth-12"
						[ngClass]="{
							'table-color-def-1': rInfractionItem.DefinedByID == 1,
							'table-color-def-2': rInfractionItem.DefinedByID == 2,
							'table-color-def-3': rInfractionItem.DefinedByID == 3,
							'table-color-def-4': rInfractionItem.DefinedByID == 4
						}"
					>
						{{ rInfractionItem.DefinedByDesc }}
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						  -->
<!-- Display When No Location -->
<!-- 					      -->
<div style="padding: 20px" [style.display]="lstInfraction.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No infractions configured...</label>
</div>
